export default __webpack_public_path__ + "static/media/Fine_IMG0661.7bd4a7ca.jpg";